module.exports = __webpack_public_path__ + "static/media/ranking de grupos aseguradores_en.4b3e41e1.svg";